import * as React from 'react';
import styled, { createGlobalStyle, withTheme } from 'styled-components';
import { connect } from 'react-redux';
import {
  Tooltip,
  // $FlowFixMe
} from '@bijie/react-bnb';
// $FlowFixMe
import { getLabel } from '../../utils/i18n';
import withi18n from '../../utils/withI18n';
import FlexBox from '../FlexBox';
import { getAssetMinTradeInfo } from '../../actions/actionsSet/asset';
import { Link } from '../../routes';

const TradeRuleTipInject = createGlobalStyle`
 .rule-tip .bnc-tooltip-inner{
   padding:0;
 }
 .rule-tip .bnc-tooltip-arrow{
   display:none;
 }
`;

const Wrap = styled(FlexBox)`
  font-family: IBM Plex Sans;
  background-color:${({ theme }) => theme.tooltipBg};
  color:${({ theme }) => theme.fontColor};
  padding:16px;
  div{
  line-height:18px;
  }
  .title{
    padding-right:24px;
  }
  a{
    color: ${({ theme }) => theme.highlight};
  }
`;
const WrapAll = styled.div`
  display: inline-flex;
  align-items: center;
  cursor: pointer;
`;
const mapStateToProps = ({
  tickers,
  locale,
  assetMinTradeInfo,
}) => ({
  tickers,
  locale,
  assetMinTradeInfo,
});
type Props = {
  i18n: Object,
  locale: string,
  tickers: Array<Object>,
  getAssetMinTradeInfo: Function,
  assetMinTradeInfo: Array<Object>,
  pair: Array<string>,
}

const mapDispatchToProps = ({
  getAssetMinTradeInfo,
});
export default
@withi18n
@withTheme
@connect(
  mapStateToProps,
  mapDispatchToProps
)
class TradeRuleTip extends React.Component<Props> {
  static defaultProps = {
    locale: 'en',
    pair: [],
    i18n: {},
    assetMinTradeInfo: [],
    getAssetMinTradeInfo: () => {},
  };

  componentDidMount() {
    this.props.getAssetMinTradeInfo({ symbol: this.props.pair.join('') });
  }

  componentDidUpdate({ pair }: Props) {
    if (this.props.pair !== pair) {
      this.props.getAssetMinTradeInfo({ symbol: this.props.pair.join('') });
    }
  }

  render() {
    const {
      assetMinTradeInfo, pair, locale, i18n,
    } = this.props;
    const rule = assetMinTradeInfo.find(x => x.baseAsset === pair[0] && x.quoteAsset === pair[1]) || {};
    const overlay = (
      <Wrap direction="column">
        <FlexBox direction="row" justify="space-between">
          <FlexBox className="title">{getLabel('exchange-common-minTradeAmount', i18n)}:</FlexBox>
          <FlexBox className="content">{rule.minTradeAmount} {rule.baseAsset}</FlexBox>
        </FlexBox>
        <FlexBox direction="row" justify="space-between">
          <FlexBox className="title">{getLabel('exchange-common-minPriceMovement', i18n)}:</FlexBox>
          <FlexBox className="content">{rule.minTickSize} {rule.quoteAsset}</FlexBox>
        </FlexBox>
        <FlexBox direction="row" justify="space-between">
          <FlexBox className="title">{getLabel('exchange-common-minOrderSize', i18n)}:</FlexBox>
          <FlexBox className="content">{rule.minOrderValue} {rule.quoteAsset}</FlexBox>
        </FlexBox>
        <FlexBox direction="row" justify="space-between">
          <FlexBox className="title">{getLabel('exchange-common-maxMarketOrderAmount', i18n)}:</FlexBox>
          <FlexBox className="content">{rule.maxMarketOrderQty === null ? '--' : `${rule.maxMarketOrderQty} ${rule.baseAsset}`}</FlexBox>
        </FlexBox>
        {/* <FlexBox direction="row" justify="space-between">
          <FlexBox className="title">{getLabel('exchange-common-minMarketOrderAmount', i18n)}:</FlexBox>
          <FlexBox className="content">{rule.minMarketOrderQty === null ? '--' : `${rule.minMarketOrderQty} ${rule.baseAsset}`}</FlexBox>
        </FlexBox> */}
        <FlexBox direction="row" justify="space-between">
          <Link to={`/${locale}/trade-rule`}><a target="_blank">{getLabel('exchange-common-viewMore', i18n)} &gt;</a></Link>
        </FlexBox>
      </Wrap>
    );

    return (
      <WrapAll>
        <TradeRuleTipInject />
        <Tooltip placement="top" trigger={['hover']} overlay={overlay} overlayClassName="rule-tip">
          <span>{getLabel('exchange-tradeRule-title', i18n)}</span>
        </Tooltip>
      </WrapAll>
    );
  }
}
